import * as React from "react";
const SvgRooftop = ({ title, titleId, ...props }) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      d="M17 2a4 4 0 0 0-4 4v.75c0 1.953 1.4 3.579 3.25 3.93V12H2.75a.75.75 0 0 0-.75.75v2.502c0 .415.336.75.75.75H3v5.248a.75.75 0 0 0 1.5 0v-5.248h15v5.248a.75.75 0 0 0 1.5 0v-5.248h.25a.75.75 0 0 0 .75-.75V12.75a.75.75 0 0 0-.75-.75h-3.5v-1.32A4.001 4.001 0 0 0 21 6.75V6a4 4 0 0 0-4-4Zm.75 7.136V7a.75.75 0 0 0-1.5 0v2.136A2.501 2.501 0 0 1 14.5 6.75V6a2.5 2.5 0 0 1 5 0v.75c0 1.12-.736 2.067-1.75 2.386ZM6.25 13.5v1.002H3.848a.773.773 0 0 0-.196 0H3.5V13.5h2.75Zm1.5 1.002V13.5h3.5v1.002h-3.5Zm5-1.002h3.5v1.002h-3.5V13.5Zm5 1.002V13.5h2.75v1.002h-.152a.773.773 0 0 0-.196 0H17.75Z"
      fill="currentColor"
    />
    <path
      d="M3 6a3 3 0 1 1 6 0 3 3 0 0 1-6 0Zm3-1.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3ZM6 17.75a.75.75 0 0 1 .75-.75h3.5a.75.75 0 0 1 .75.75v3.5a.75.75 0 0 1-.75.75h-3.5a.75.75 0 0 1-.75-.75v-3.5Zm1.5.75v2h2v-2h-2ZM13.75 17a.75.75 0 0 0-.75.75v3.5c0 .414.336.75.75.75h3.5a.75.75 0 0 0 .75-.75v-3.5a.75.75 0 0 0-.75-.75h-3.5Zm.75 3.5v-2h2v2h-2Z"
      fill="currentColor"
    />
  </svg>
);
export default SvgRooftop;
